import { serviceBase } from './serviceBase';
import axiosClient from './axiosClient';

// eslint-disable-next-line import/prefer-default-export
export const resendSignEmail = serviceBase({
  request: weetrustDocId =>
    axiosClient.post('/contracts/resend-signature-link', { weetrustDocId })
});
